import {observer} from "mobx-react-lite";
import Select from "react-select";
import {syncOrdersController as controller} from "../../store/pageControllers/syncOrdersController";
import SyncOrdersApi, {LabelValue, OzonStateAndShopAction} from "../../api/SyncOrdersApi";
import React, {useState} from "react";
import {selectStyler} from "../../components/SelectStyler";

export const ActionComparison = observer(({
                                              pair,
                                              model,
                                              eventSender, isMulti
                                          }: { pair: OzonStateAndShopAction, model: string, eventSender: string, isMulti: boolean }) => {
    const [getShopAction, setShopAction] = useState<LabelValue | LabelValue[] | undefined | null>(pair.shopAction)
    const selectParams = {
        ...selectStyler,
        placeholder: "Действие в магазине",
        isClearable: true,
        options: controller.shop_states
    }

    let pName = pair.ozonState.value.indexOf('cancelled_') > -1 ? 'cancelled' : pair.ozonState.value
    return <>
        <div className={"flexbox full-width bordered-bottom"}>
            <div className={"wide custom-px-16 custom-py-12 width-50"} style={{display: 'flex'}}>
                <div style={{display: 'flex', width: '100%'}}>
                    <div style={{width: '42%'}}>{pair.ozonState.label} ({pName})</div>

                    <div style={{width: '10%'}}><i className="fa fa-angle-right gray" aria-hidden="true"/></div>
                    <div style={{width: '48%'}} className={"width-50 custom-px-0"}>
                        {isMulti ?
                            <Select
                                isMulti={true}
                                value={getShopAction}
                                onChange={(shopActions) => {
                                    if (shopActions) {
                                        SyncOrdersApi.setStateActionPairs(pair.ozonState.value, shopActions, model, eventSender)
                                        setShopAction([...shopActions])
                                        pair.shopAction = [...shopActions]
                                    } else {
                                        SyncOrdersApi.delStateActionPair(pair.ozonState.value, model, eventSender)
                                        setShopAction(undefined)
                                        pair.shopAction = shopActions
                                    }
                                }
                                }
                                {...selectParams}
                            /> : <Select
                                isMulti={false}
                                value={getShopAction}
                                onChange={(shopAction) => {
                                    if (shopAction) {
                                        SyncOrdersApi.setStateActionPair(pair.ozonState.value, shopAction.value, model, eventSender)
                                        setShopAction(shopAction)
                                    } else {
                                        SyncOrdersApi.delStateActionPair(pair.ozonState.value, model, eventSender)
                                        setShopAction(undefined)
                                    }
                                    pair.shopAction = shopAction
                                }}
                                {...selectParams}
                            />
                        }

                    </div>
                </div>

            </div>

        </div>
    </>
})